
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {
  PurchaseOrderProductInfos,
  FactoryInfos,
  FinancialConfiguration, PurchaseOrderProductInfosMore,
} from "@/model/FinancialBookingModels";
import {
  FactoryInvoices,
  FactoryInvoiceProducts,
} from "@/model/factory-invoices";
import {divide} from "@/utils/number";
import {isEmpty, toUpper} from "lodash";
import {LoadingPlanType} from "@/views/sales-management/SalesBookingOrderManagement.vue";
import {
  getAllDeclarationElements,
  getDeclarationElements,
  getDeclarationElementsVersion
} from "@/api/declaration-element";
import {deepClone} from "@/utils/deepClone";

/**
 * 报关单据表格
 */
@Component({
  name: "AuditTable",
})
export default class extends Vue {
  @Prop({required: true}) private data: FactoryInvoiceProducts[];
  @Prop({required: false}) private detail: FactoryInvoices;
  @Prop({required: true})
  private financialConfiguration: FinancialConfiguration;
  @Prop({required: false}) private item: FactoryInfos;
  @Prop({required: false, default: false}) private useInvoiceMoney: boolean;
  @Prop({required: false, default: false}) private confirm: boolean;
  private data_: FactoryInvoiceProducts[] = [];
  private maxIndex: number;

  @Watch("data", {immediate: true})
  private async watchData() {
    await this.getList();
    this.data_ = deepClone(this.data);
    this.data_.forEach((item, index) => {
      this.getListItem(item.invoiceDescription, index);
    });
    await this.getMaxIndex();
  }

  private getQuantity() {
    this.$emit("calculateTotal", "quantity");
  }

  private async getMaxIndex() {
    const arr = this.data.map((item) => {
      return item.totalDeclarationAmount;
    });
    this.maxIndex = this.data.findIndex((item) => {
      return item.totalDeclarationAmount === Math.max(...arr);
    });
  }

  private getPurchaseOrderNumberAndBatch(row: PurchaseOrderProductInfosMore) {
    return row.batch === null ? row.purchaseOrderNumber:
        row.purchaseOrderNumber + "(" + row.batch + ")";
  }

  private getPaymentAmount(rows: FactoryInvoiceProducts) {
    return rows.returnSettlementAmount - rows.deductionAndFilling + rows.purchaseOrderFee;
  }

  // 调整品名总金额=上传品名单价*数量-贴标费用-索赔费用-其他费用（-50+50）-补扣款
  private getTotalAdjustAmount(rows: FactoryInvoiceProducts) {
    rows.totalAdjustAmount =
      rows.returnSettlementAmount -
      rows.otherCharge -
      rows.deductionAndFilling +
      rows.purchaseOrderFee;
    this.$emit("calculateTotal", "totalAdjustAmount");
    return rows.totalAdjustAmount;
  }

  // 调整单价=调整品名总金额/数量或重量（根据结算单位）
  private getAdjustUnitPrice(rows: FactoryInvoiceProducts) {
    if(rows.settlementUnit.includes("KG")){
      rows.adjustUnitPrice = divide(rows.totalAdjustAmount, rows.weight, 4);
    }else {
      rows.adjustUnitPrice = divide(rows.totalAdjustAmount, rows.quantity, 4);
    }
    return rows.adjustUnitPrice;
  }

  private showExtraDialog() {
    this.$emit("showExtraDialog");
  }

  private getExtraInfo(item) {
    this.data_[this.maxIndex].deductionAndFilling = item.deductionAndFilling;
    this.data_[this.maxIndex].deductionAndFillingRemark =
        item.deductionAndFillingRemark;
  }

  private canEditNumber(row: FactoryInvoiceProducts) {
    return (row.settlementUnit && row.settlementUnit.indexOf("千克") === -1);
  }

  private listQuery = {};
  private total = 0;
  private selectList = [];

  private async getList() {
    const params = {
      pageNumber: 1,
      pageSize: 1000,
    };
    const data: any = await getDeclarationElementsVersion();
    this.selectList = data;
  }

  private async getListItem(invoiceDescription: string, index: number) {
    let list = this.selectList.filter((item) => {
      if (item.customsProductName === invoiceDescription){
        return item;
      }
    });
    // let selectUnit = [];
    if (list.length) {
      // selectUnit = [
      //   {label: list[0].firstUnit, value: list[0].firstUnit},
      //   {label: list[0].secondUnit, value: list[0].secondUnit},
      // ];
      // this.data_[index].selectUnit = selectUnit;
      this.data_[index].settlementUnit = this.data_[index].settlementUnit
          ? this.data_[index].settlementUnit
          : list[0].firstUnit;
    }
  }
}

export class LoadingPlanListTableRowData {
  id: string;
  code: string;
  createdDate: string;
  containerType: string;
  type: LoadingPlanType;
  category: string;
  loadingPlace: string;
  containerInfo: string;
  totalProductQuantity: number;
  totalAmount: string;
  totalVolume: string;
  select: boolean;

  isMatch(code?: string, category?: string, factoryName?: string): boolean {
    let match = true;
    if (!isEmpty(code)) {
      match = this.code.includes(toUpper(code));
    }
    if (!isEmpty(category)) {
      match = match && this.category === category;
    }
    if (!isEmpty(factoryName)) {
      match = match && this.loadingPlace.includes(factoryName);
    }
    return match;
  }
}
